export let entityTypes = {
  'company': 'Ettevõte',
  'person': 'Füüsiline isik'
}

export let representativeTypes = {
  'boardmember': 'Juhatuse liige',
  'worker': 'Kontaktisik',
  'attorney': 'Volikirja alusel',
  'other': 'Muu'
}

export let utils = {

  asSelectOptions: (obj) => {
    return Object.keys(obj).map(key => {
      return {
        value: key,
        text: obj[key]
      }
    })
  }
}
